export var VELT_SDK_VERSION = '4.3.0-beta.5';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
